// extracted by mini-css-extract-plugin
export default {"main":"app_main__F8uIB","mainContent":"app_mainContent__+GAtA"};